import { UniversalCard } from '@components/core-ui/UniversalCard';
import { routes } from '@routes';
import { MeResponseDtoOrganization } from 'app/API';
import { useNavigate } from 'react-router-dom';

type TProps = {
  organization: MeResponseDtoOrganization;
};

export const OrganizationCard = ({ organization }: TProps) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(routes.dashboard.make(organization.slug));
  };

  const onDetailsClick = (organization: MeResponseDtoOrganization) => {
    navigate(routes.organizationDetails.make(organization.slug));
  };

  const actions = [{ label: 'Details', onClick: () => onDetailsClick(organization) }];

  const content = (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        href={routes.dashboard.make(organization.slug)}
        className="font-medium text-[var(--color-title)] hover:text-foreground-muted"
      >
        {organization.name || organization.slug}
      </a>
      <p>&nbsp;</p>
      <p className="text-foreground-muted text-xs">
        {organization.userCount} {organization.userCount === 1 ? 'member' : 'members'}
      </p>
    </>
  );

  return (
    <UniversalCard
      content={content}
      name={organization.name || organization.slug}
      actions={actions}
      image={organization.image}
      onClick={() => onClick()}
    />
  );
};
